module.exports = __webpack_public_path__ + "img/report.6d14cb7b.png";